import { render, staticRenderFns } from "./PaidDownloadButtons.vue?vue&type=template&id=6ca35097&scoped=true"
import script from "./PaidDownloadButtons.vue?vue&type=script&lang=ts"
export * from "./PaidDownloadButtons.vue?vue&type=script&lang=ts"
import style0 from "./PaidDownloadButtons.vue?vue&type=style&index=0&id=6ca35097&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca35097",
  null
  
)

export default component.exports